// start:ng42.barrel
export * from './data.validators';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/validators/index.ts